"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallFailedError = void 0;
class CallFailedError extends Error {
}
exports.CallFailedError = CallFailedError;
